import Typography from "material-ui/Typography";
import React from "react";
import Grid from "material-ui/Grid";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import WiremapDiagram from "../wiremap/diagram";
import List from "material-ui/List";
import { ListItem, ListItemText } from "material-ui";
import Card, { CardContent } from "material-ui/Card";
import WiremapTable from "../wiremap/table";
import WiremapGenerator from "../../../../../common/wiremapGenerator";
import Voltagediagram from "../wiremap/voltagediagram";
import { dateTimeFormatter } from "../../../../../common/utils";

class MobileTestSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAll: false,
      showImage: true,
    };
    this.toggleShowAll = this.toggleShowAll.bind(this);
    this.hideImage = this.hideImage.bind(this);
  }

  componentWillMount() {
    const { getSubtestResults, pager } = this.props;

    getSubtestResults(pager.jid, pager.tid, "Wiremap", null);
  }

  render() {
    const {
      classes,
      translate,
      results,
      subtestResultsWiremap,
      wiremapStandard,
      chartMeasurementUnit,
    } = this.props;

    const isPoeResult = results.data.mobileTest.service.includes("PoE");
    const isServiceResult =
      isPoeResult ||
      results.data.mobileTest.service == "ISDN" ||
      results.data.mobileTest.service == "POTS";
    // Note: Service can be 'Ethernet' or 'Ethernet & PoE', do exact comparison
    const isEthernetOnly = results.data.mobileTest.service === "Ethernet";
    const isPassResult = results.data.mobileTest.overallResult === "Pass";
    const isFailResult = results.data.mobileTest.overallResult === "Fail";

    chartMeasurementUnit &&
      WiremapGenerator.setChartMeasurementUnit(chartMeasurementUnit);
    translate && WiremapGenerator.setTranslate(translate);

    const imageUrl =
      process.env.REACT_APP_BASEURL +
      "test/mobile/" +
      results.data.mobileTest.id +
      "/image";

    let wiremapData = null;

    if (results) {
      if (results.data && subtestResultsWiremap) {
        if (results.data.mobileTest.videoCableModeSelected) {
          wiremapData = {
            ...subtestResultsWiremap,
            Details: subtestResultsWiremap.Details.filter(
              (item) => item.DHPin == "1" || item.DHPin == "2"
            ),
          };
        } else if (results.data.mobileTest.voiceCableModeSelected) {
          wiremapData = {
            ...subtestResultsWiremap,
            Details: subtestResultsWiremap.Details.filter(
              (item) =>
                item.DHPin == "1" ||
                item.DHPin == "2" ||
                item.DHPin == "3" ||
                item.DHPin == "4" ||
                item.DHPin == "5" ||
                item.DHPin == "6"
            ),
          };
        } else {
          wiremapData = {
            ...subtestResultsWiremap,
            Details: subtestResultsWiremap.Details,
          };
        }

        // When generating diagram, we need to use max pins length, rather than ref length
        let maxLength = Math.max(
          ...wiremapData.Details.map((o) => o.ConnectionLength),
          wiremapData.RefLength
        );
        wiremapData = { ...wiremapData, RefLength: maxLength };
      }

      const poeClass = results.data.mobileTest.poeClass.split("class ")[1];
      const poeStandard = results.data.mobileTest.poeClass.split("-")[0];

      let remoteId = results.data.mobileTest.hasConnectedRemote
        ? results.data.mobileTest.connectedRemote
        : results.data.mobileTest.connectedIdentifier;

      if (remoteId === 0) {
        remoteId = "-";
      }

      var nvpLabel = "NVP";
      var nvpValue = (results.data) ? results.data.mobileTest.nominalVelocityOfPropagation : 0;
      if (results.data && (results.data.devicetype == "VDVIIPlus")) {
        nvpLabel = (chartMeasurementUnit === "meters" || chartMeasurementUnit === "meter") ? translate("pF_m") : translate("pF_ft");
        nvpValue = WiremapGenerator.getCapacitanceFromNVP(nvpValue);
      }
      var hideLengthAndNVP = results.data && (results.data.devicetype == "VDVII");
      var hideLinkSpeed = results.data && (results.data.devicetype == "VDVII" || results.data.devicetype == "VDVIIPlus");

      return (
        <Grid container className={classes.resultsViewer}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid
              container
              xs={12}
              className={classes.testInfo}
              style={{ textAlign: "center" }}
            >
              <Grid item xs>
                <Typography type="subheading" className={classes.testDetails}>
                  <strong>{translate("mobiletest_operatorname")}</strong>:
                  {results.data.engineer}
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography type="subheading" className={classes.testDetails}>
                  <strong>{translate("job_device")}</strong>:
                  {translate(results.data.devicetype.toLowerCase())}{" "}
                  {results.data.device}
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography type="subheading" className={classes.testDetails}>
                  <strong>{translate("result_testtime")}</strong>:
                  {dateTimeFormatter(results.data.testtime)}
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography type="subheading" className={classes.testDetails}>
                  <strong>{translate("mobiletest_mode")}</strong>:
                  {results.data.mobileTest.dataCableModeSelected && "Data"}
                  {results.data.mobileTest.videoCableModeSelected && "Video"}
                  {results.data.mobileTest.voiceCableModeSelected && "Voice"}
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography type="subheading" className={classes.testDetails}>
                  <strong>{translate("mobiletest_cableinformation")}</strong>:
                  {results.data.mobileTest.cableInformation}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={24}>
              {/*Left Column*/}
              <Grid item xs={12} md={6}>
                {!isEthernetOnly && (
                  <Card style={{ marginBottom: "1.4em" }}>
                    <CardContent>
                      {isServiceResult && (
                        <React.Fragment>
                          <Typography type="headline">
                            {translate("voltage_diagram")}
                          </Typography>
                          <hr />
                          <Voltagediagram
                            data={
                              results && results.data && subtestResultsWiremap
                            }
                            mobileTest={results.data.mobileTest}
                            wiremapStandard={wiremapStandard}
                            translate={translate}
                            results={results}
                          ></Voltagediagram>
                        </React.Fragment>
                      )}

                      {!isServiceResult && (
                        <React.Fragment>
                          <Typography type="headline">
                            {translate("wiremap")}
                          </Typography>
                          <hr />
                          <WiremapDiagram
                            data={results && results.data && wiremapData}
                            wiremapStandard={wiremapStandard}
                            translate={translate}
                            results={results}
                          />
                        </React.Fragment>
                      )}

                      {!isServiceResult && subtestResultsWiremap && !hideLengthAndNVP && (
                        <React.Fragment>
                          <Typography
                            variant="caption"
                            gutterBottom
                            align="center"
                          >
                            {translate("wiremap_length")}:
                            {WiremapGenerator.convertMeasurementUnitVDV(
                              subtestResultsWiremap.RefLength || 0,
                              translate
                            )}
                          </Typography>
                          {results.data.mobileTest
                            .nominalVelocityOfPropagation && (
                            <Typography
                              variant="caption"
                              gutterBottom
                              align="right"
                            >
                              <strong>
                                {nvpLabel}:{" "}
                                {nvpValue}
                              </strong>
                            </Typography>
                          )}
                        </React.Fragment>
                      )}

                      {isFailResult && !isServiceResult && !isPassResult && (
                        <WiremapTable
                          data={results && results.data && wiremapData}
                          translate={translate}
                          chartMeasurementUnit={chartMeasurementUnit}
                          isCoax={
                            results &&
                            results.data &&
                            results.data.mobileTest.videoCableModeSelected
                          }
                          hideLength={results.data && results.data.devicetype == "VDVII"}
                          isMobileTest={true}
                        />
                      )}
                    </CardContent>
                  </Card>
                )}
              </Grid>

              {/*Right Column*/}
              <Grid item xs={12} md={6}>
                {!isServiceResult && !isEthernetOnly && (
                  <Card style={{ marginBottom: "1.4em" }}>
                    <CardContent>
                      <Typography type="headline">
                        {translate("remote_id")}: {remoteId}
                      </Typography>
                    </CardContent>
                  </Card>
                )}

                {isPoeResult && (
                  <Card style={{ marginBottom: "1.4em" }}>
                    <CardContent>
                      <Typography type="headline">
                        {translate("mobiletest_poeclass")}: {poeClass}
                      </Typography>
                      <hr />

                      <Grid container>
                        <Grid xs={6}>
                          <List>
                            <ListItem>
                              <ListItemText
                                primary={translate("poe_standard") + ":"}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText
                                primary={translate("power") + ":"}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText
                                primary={translate("voltage_load") + ":"}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText
                                primary={translate("voltage_offload") + ":"}
                              />
                            </ListItem>
                          </List>
                        </Grid>
                        <Grid xs={6}>
                          <List>
                            <ListItem>
                              <ListItemText primary={poeStandard} />
                            </ListItem>
                            <ListItem>
                              <ListItemText
                                primary={
                                  results.data.mobileTest.poePowerInWatts + "W"
                                }
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText
                                primary={
                                  results.data.mobileTest.onloadVoltageInVolts +
                                  "V"
                                }
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText
                                primary={
                                  results.data.mobileTest
                                    .offloadVoltageInVolts + "V"
                                }
                              />
                            </ListItem>
                          </List>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                )}

                {(isPoeResult || isEthernetOnly) && !hideLinkSpeed && (
                  <Card style={{ marginBottom: "1.4em" }}>
                    <CardContent>
                      <Typography type="headline">
                        {translate("mobiletest_linkpulse")}:{" "}
                        {results.data.mobileTest.linkPulse}
                      </Typography>
                    </CardContent>
                  </Card>
                )}

                {(isServiceResult || isEthernetOnly) && (
                  <Card style={{ marginBottom: "1.4em" }}>
                    <CardContent>
                      <Typography type="headline">
                        {translate("service_detected")}:{" "}
                        {results.data.mobileTest.service}
                      </Typography>
                    </CardContent>
                  </Card>
                )}

                {this.state.showImage && (
                  <Card style={{ marginBottom: "1.4em" }}>
                    <CardContent>
                      {/*<Typography type="headline">*/}
                      {/*  {translate("test_image")}*/}
                      {/*</Typography>*/}
                      {/*<hr />*/}

                      <div style={{ textAlign: "center" }}>
                        <img
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                          src={imageUrl}
                          alt="image"
                          onError={() => {
                            this.hideImage();
                          }}
                        />
                      </div>
                    </CardContent>
                  </Card>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      return <Typography type="button">No data</Typography>;
    }
  }

  toggleShowAll() {
    this.setState({
      showAll: !this.state.showAll,
    });
  }

  hideImage() {
    this.setState({
      showImage: false,
    });
  }
}

export default withStyles(styles)(MobileTestSummary);
